import { useIntl } from 'react-intl';

import { Col, Form, InputNumber, Row, Typography } from 'antd';

import { useWorkJourneyContext } from '@src/packages/workJourney/contexts';
import IntlMessages from '@src/util/IntlMessages';

import styles from '../../../styles.module.less';
import { blockNonDigitKeyDown, digitsOnlyFormatter, digitsOnlyParser } from './numericInputProps';

const { Paragraph } = Typography;

const EarlyTerminationSelector = () => {
  const { workJourneyForm, setWorkJourneyForm } = useWorkJourneyContext();
  const { earlyEndTime } = workJourneyForm;
  const intl = useIntl();

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Paragraph className={styles.descriptionText}>
            <IntlMessages id="workJourney.earlyTerminationDescription" />
          </Paragraph>
        </Col>
      </Row>

      <Row className={styles.formSectionRow}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Form.Item>
            <div className={styles.formItemLine}>
              <InputNumber
                onWheel={e => (e.target as HTMLInputElement).blur()}
                onKeyDown={blockNonDigitKeyDown}
                min={0}
                max={120}
                formatter={digitsOnlyFormatter}
                parser={digitsOnlyParser}
                value={earlyEndTime}
                onChange={value => {
                  const nextEarlyEndTime =
                    typeof value === 'number' && Number.isFinite(value) ? Math.trunc(value) : 0;
                  setWorkJourneyForm({ ...workJourneyForm, earlyEndTime: nextEarlyEndTime });
                }}
              />
              <span className={styles.minutes}>
                {intl.formatMessage({ id: 'workJourney.minutes' })}
              </span>
            </div>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default EarlyTerminationSelector;
